<template>
  <div class="search-new-d__results">
    <div class="search-results-new-d _d js-search-results">
      <template v-if="list.length > 0">
        <div
          v-if="getSimpleSuggesting.length"
          class="search-results-new-d__list"
        >
          <div
            v-for="item in getSimpleSuggesting"
            :key="item.link"
            class="search-results-new-d__item"
          >
            <a
              v-if="!item.meta.bread_crumb"
              :href="item.link"
              class="search-results-new-d__link js-suggest-item"
              @click="clickLinkHandler(item.title)"
            >
              <span v-html="getSearchCaption(item.title, query)"></span>
            </a>
          </div>
        </div>
        <div
          v-if="getCategories.length"
          class="search-results-new-d__categories"
        >
          <div
            v-for="item in getCategories"
            :key="item.link"
            class="search-results-new-d__item"
          >
            <suggest-category-item-d
              v-if="item.meta.bread_crumb"
              :key="item.link"
              :title="item.title"
              :link="item.link"
              :breadcrumbs="item.meta.bread_crumb"
              :query="query"
              @clickHandler="(e) => clickLinkHandler(e)"
            />
          </div>
        </div>
        <div
          v-if="getProductsList.length"
          class="search-results-new-d__products"
        >
          <div
            v-for="item in getProductsList"
            :key="item.meta.id"
            class="search-results-new-d__item"
          >
            <search-product
              :id="item.meta.id"
              :url="item.link"
              :name="item.title"
              :price-base="item.meta.original_price"
              :price="item.meta.price"
              :percent-discount="item.meta.discount"
              :img="item.meta.image"
              :query="query"
              @clickHandler="clickLinkHandler(item.title)"
            />
          </div>
        </div>
      </template>
      <template v-else-if="!list.length">
        <div v-if="history.length > 0" class="search-results-new-d__home">
          <div class="search-results-new-d__title">
            Вы уже искали
            <button
              type="button"
              class="search-results-new-d__clear"
              @click.prevent="$emit('clear-history')"
            >
              Очистить
            </button>
          </div>
          <div class="search-results-new-d__list">
            <div
              v-for="(item, key) in history"
              :key="item"
              class="search-results-new-d__item"
            >
              <a
                :href="`/search/?q=${item}`"
                class="search-results-new-d__link js-suggest-item"
                rel="nofollow"
              >
                {{ item }}
              </a>
              <button
                type="button"
                class="search-results-new-d__item-clear"
                @click.prevent="$emit('clear-history', key)"
              >
                <icon
                  name="Close_24"
                  class="search-results-new-d__item-clear-icon"
                  width="24"
                  height="24"
                />
              </button>
            </div>
          </div>
        </div>
        <div v-if="popular.length > 0" class="search-results-new-d__home">
          <div class="search-results-new-d__title">
            Популярные запросы
          </div>
          <div class="search-results-new-d__list">
            <div
              v-for="item in popular"
              :key="item.phrase"
              class="search-results-new-d__item"
            >
              <a
                :href="`/search/?q=${item.phrase}`"
                class="search-results-new-d__link js-suggest-item"
                rel="nofollow"
                @click="clickLinkHandler(item.phrase)"
              >{{ item.phrase }}</a>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AutocompleteMixin from '@/js/helpers/mixins/AutocompleteMixin';

import SuggestCategoryItemD from '@/js/vue/SuggestCategoryItemD';
import SearchProduct from '@/js/vue/SearchProduct/SearchProduct';
import Icon from '@/js/vue/Icon';

export default {
  name: 'SuggestListSearchD',
  components: {
    SuggestCategoryItemD,
    Icon,
    SearchProduct,
  },
  mixins: [AutocompleteMixin],
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    popular: {
      type: Array,
      default: () => ([]),
    },
    history: {
      type: Array,
      default: () => ([]),
    },
    isShowError: {
      type: Boolean,
      default: false,
    },
    isQueryAlreadyExist: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isTouched: false,
    };
  },
  watch: {
    query() {
      this.isTouched = true;
    },
  },
};
</script>
